<template>
  <v-app id="post-login">
    <v-main>
      <v-container class="fill-height" fluid :style="{ background: 'url(' + require('@/assets/bg.jpg') + ') center center / cover' }">
        <v-row align="center" justify="center">
          <v-overlay z-index="0" opacity="0.6" absolute></v-overlay>
          <v-overlay z-index="10" :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-col cols="12" sm="8" md="3" lg="3" style="z-index: 1">
            <v-card class="elevation-1 pa-3" v-if="!addForm">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/logo.png" alt="Logo" width="120" height="120">
                </div>
                <div class="mt-3" style="text-align: center; font-weight: bold;">Introduce matrícula/bastidor/IIC</div>
                <div>
                  <v-autocomplete
                    v-model="selectedVehicle"
                    :items="vehiculoState.list"
                    :loading="vehiculoState.loading"
                    :search-input.sync="vehiculoState.search"
                    :disabled="loading"
                    :filter="filterVehiculos"
                    :item-text="displayText"
                    item-value="id"
                    label="Vehiculo"
                    hide-details="auto"
                    hide-no-data
                    hide-selected
                    return-object
                    required
                    outlined
                    :menu-props="{
                      maxHeight: 400,
                      contentClass: 'vehicle-autocomplete-menu'
                    }"
                    @input="handleVehicleInput"
                    @change="handleVehicleChange"
                  >
                    <template v-slot:item="data">
                      <v-list-item 
                        :class="getVehicleItemClass(data.item)"
                        class="vehicle-list-item"
                        @click="data.item.__onlyVehicle ? handleOnlyVehicleClick(data.item) : handleItemClick(data.item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon small class="mr-1" :color="data.item.status === 'free' ? 'teal' : (data.item.__onlyVehicle ? 'primary' : '')">
                              {{ data.item.__onlyVehicle ? 'mdi-car' : (data.item.status === 'free' ? 'mdi-car-key' : (data.item.movements && data.item.movements.length > 0 ? 'mdi-car-arrow-right' : 'mdi-car')) }}
                            </v-icon>
                            {{ data.item.brand }} {{ data.item.model }}
                          </v-list-item-title>
                          <v-list-item-title style="font-size: 0.95em; font-weight: normal;">
                            {{ data.item.frame_number ? 'B: ' + ((data.item.frame_number && data.item.frame_number.length > 6) ? '...' + data.item.frame_number.slice(-6) : data.item.frame_number) + ' / ' : '' }} {{ data.item.plate_number ? 'M: ' + data.item.plate_number : '' }}
                            <span v-if="!data.item.__onlyVehicle && getPendingMovements(data.item).length">
                              <span
                                v-for="mov in getPendingMovements(data.item)"
                                :key="mov.id"
                                :class="getMovementClass(mov)"
                              >
                                <template v-if="mov.type === 'assignment'">
                                  <template v-if="mov.status === 'reported'"> - Cesión reportada</template>
                                  <template v-else-if="mov.status === 'processing'"> - Cesión en proceso</template>
                                </template>
                                <template v-else>
                                  <template v-if="mov.status === 'unreported'"> - Petición de movimiento</template>
                                  <template v-if="mov.status === 'reported'"> - Movimiento reportado</template>
                                  <template v-if="mov.status === 'processing'"> - Movimiento en proceso</template>
                                  <template v-if="mov.type === 'entry'"> - Vehículo recepcionado</template>
                                </template>
                              </span>
                            </span>
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="data.item.dealer">
                            <v-icon small class="mr-1">mdi-store</v-icon>
                            <span class="font-weight-medium">{{ data.item.dealer.name }}</span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <span v-if="!data.item.__onlyVehicle && getLastMovement(data.item) && getLastMovement(data.item).type === 'assignment'">
                              Cesión:
                              <span v-if="getLastMovement(data.item).datetime">
                                <span v-if="getLastMovement(data.item).delivery_date">
                                  Inicio: {{ formatAssignmentDate(getLastMovement(data.item).delivery_date) }}
                                </span>
                                <span v-else>
                                  Inicio: {{ formatAssignmentDate(getLastMovement(data.item).datetime) }}
                                </span>
                              </span>
                              <span v-if="getLastMovement(data.item).end_date">
                                &nbsp;|&nbsp; Fin: {{ formatAssignmentEndDate(getLastMovement(data.item).end_date) }}
                              </span>
                            </span>
                            <span v-else-if="!data.item.__onlyVehicle && getLastMovement(data.item) && getLastMovement(data.item).type === 'move'">
                              Movimiento:
                              <span v-if="getLastMovement(data.item).source_location_id">
                                Origen: {{ getLocationName(data.item, getLastMovement(data.item), getLastMovement(data.item).source_location_id) }}
                              </span>
                              <span v-if="getLastMovement(data.item).destination_location_id">
                                &nbsp;|&nbsp; Destino: {{ getLocationName(data.item, getLastMovement(data.item), getLastMovement(data.item).destination_location_id) }}
                              </span>
                              <br v-if="getLastMovement(data.item).datetime || getLastMovement(data.item).end_date">
                              <span v-if="getLastMovement(data.item).delivery_date">
                                  Inicio: {{ formatAssignmentDate(getLastMovement(data.item).delivery_date) }}
                                </span>
                                <span v-else>
                                  Inicio: {{ formatAssignmentDate(getLastMovement(data.item).datetime) }}
                                </span>
                              <span v-if="getLastMovement(data.item).end_date">
                                &nbsp;|&nbsp; Fin: {{ formatAssignmentEndDate(getLastMovement(data.item).end_date) }}
                              </span>
                            </span>
                            <span v-else-if="!data.item.__onlyVehicle">
                              {{ formattedMovement(data.item) }}
                            </span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>No se encontraron resultados</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <v-alert v-if="error" type="error" class="mt-3">{{ error }}</v-alert>
                <v-alert v-if="noResults" type="info" class="mt-3">No se encontraron resultados</v-alert>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" block @click="goToDashboard">Acceder al panel</v-btn>
              </v-card-actions>
            </v-card>
            <movimiento-form v-else-if="isAddAction" @save="handleSave" @cancel="handleCancel" :vehicle="selectedVehicle"></movimiento-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <vehicle-details 
      :vehicle.sync="selectedVehicle" 
      :statusMov="lastMovement" 
      :visible="detailsVisible" 
      @close="handleVehicleDetailsClose" 
      @accept="showTransportForm"
    ></vehicle-details>
    <transport-form 
      v-if="selectedVehicle" 
      :visible="transportFormVisible" 
      :status="selectedVehicle" 
      @close="handleTransportFormClose" 
      @submit="handleTransportSubmit"
    ></transport-form>
    <v-dialog v-model="showCompleteMoveDialog" max-width="420">
      <v-card>
        <v-card-title class="headline red--text text-center">
          Atención
        </v-card-title>
        <v-card-text class="text-center">
          Para continuar con la cesión, primero debe completar la operación pendiente de este vehículo:
          <div v-if="pendingMovementSummary" class="mt-3 font-weight-medium text--primary">
            {{ pendingMovementSummary }}
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="showCompleteMoveDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import _ from 'lodash'
import VehicleDetails from './VehicleDetailMovemnt.vue'
import TransportForm from './TransportForm.vue'
import MovimientoForm from '../views/movimiento/MovimientoForm.vue'
import VehiculoService from '../services/VehiculoService'
import LocationService from '../services/LocationService'
import { locationDisplayName } from '@/utils'
import GrupoService from '../services/GrupoService'

export default {
  components: {
    VehicleDetails,
    TransportForm,
    MovimientoForm
  },
  data: () => ({
    searchQuery: '',
    lastMovement: {},
    error: '',
    noResults: false,
    movements: [],
    isAdd: false,
    addForm: false,
    vehiculoState: {
      list: [],
      loading: false,
      search: '',
      rawList: [] // lista original de vehículos con todos los movimientos
    },
    selectedVehicle: null,
    loading: false,
    scan: null,
    fields: {
      vehicle_id: null,
      foto: null
    },
  detailsVisible: false,
  transportFormVisible: false,
  showCompleteMoveDialog: false,
  pendingMovement: null,
  locationOptions: [],
  groupPartnerLocationsLoading: false,
  groupPartnerLocationsLoaded: false
  }),
  
  // Listener para cuando se vuelve a la página
  activated() {
    // Limpiar datos cuando se vuelve a activar el componente
    this.clearSearchData()
  },
  mounted() {
    this.loadLocationOptions()
  },
  methods: {
    async loadLocationOptions() {
      try {
        const hasPartners = this.$store.getters.IS_PARTNER

        let locations = []

        if (hasPartners) {
          const response = await LocationService.getPartnerLocations()
          // La respuesta viene como response.data.data.locations (hay un data anidado)
          locations = response.data?.data?.locations || []
        } else {
          const response = await LocationService.get({ 'per-page': 1000, expand: 'dealer,dealers' })
          locations = response.data?.data || []
        }

        const ownDealer = this.$store.getters.CURRENT_USER && this.$store.getters.CURRENT_USER.dealer

        this.locationOptions = locations.map(location => {
          const displayName = locationDisplayName(location, ownDealer)

          return {
            id: location.id,
            name: location.name,
            displayName: displayName,
            dealer_id: location.dealer_id,
            is_own: location.is_own !== undefined ? location.is_own : true
          }
        })
      } catch (error) {
        this.handleApiError(error, 'Error al obtener ubicaciones')
      }
    },
    handleItemClick(vehicle) {
      if (vehicle.__movementItem && vehicle.movements && vehicle.movements.length > 0) {
        const mov = vehicle.movements[0]
        if (mov.type === 'assignment') {
          const idBase = Number(vehicle.id.replace(/_mov_.+$/, ''))
          const original = this.vehiculoState.rawList.find(v => v.id === idBase)

          let allMovs = []
          if (original && original.movements) {
            allMovs = original.movements
          } else if (vehicle.originalMovements) {
            allMovs = vehicle.originalMovements
          }

          // CORREGIR: Obtener timestamps numéricos en lugar de strings
          const selectedStartMs = this.getTimestampFromDate(mov.datetime)

          // Filtrar solo movimientos no completados
          const uncompletedMovs = allMovs.filter(m => m && (m.status !== 'completed'))

          // Buscar entre TODOS los movimientos no completados si hay ALGUNO ANTERIOR
          const previousUncompleted = uncompletedMovs.find(otherMov => {
            if (!otherMov) return false

            // Ignorar el mismo movimiento seleccionado
            if (otherMov.id === mov.id) {
              return false
            }
            if (mov.status === 'unreported') {
              return false
            }

            // CORREGIR: Obtener timestamp numérico
            const otherStartMs = this.getTimestampFromDate(otherMov.datetime)

            // Si no tenemos fechas suficientes, no podemos determinar
            if (!selectedStartMs || !otherStartMs) {
              return false
            }

            // VERIFICAR: El otro movimiento es ANTERIOR (empieza antes del movimiento seleccionado)
            return otherStartMs < selectedStartMs
          })

          if (previousUncompleted) {
            this.pendingMovement = previousUncompleted
            this.showCompleteMoveDialog = true
            return
          }
        }
      }

      this.selectedVehicle = vehicle
      this.handleVehicleSelection(vehicle)
    },

    // AÑADIR ESTE MÉTODO PARA CONVERTIR A TIMESTAMP
    getTimestampFromDate(dateValue) {
      if (!dateValue) return null

      // Si ya es un timestamp numérico
      if (typeof dateValue === 'number') {
        return dateValue < 1e12 ? dateValue * 1000 : dateValue
      }

      // Si es un string de fecha, convertir a timestamp
      if (typeof dateValue === 'string') {
        const date = new Date(dateValue)
        return isNaN(date.getTime()) ? null : date.getTime()
      }

      return null
    },

    // Método para manejar input del autocomplete
    handleVehicleInput(vehicle) {
      if (vehicle) {
        this.handleVehicleSelection(vehicle)
      }
    },

    // Método para manejar change del autocomplete
    handleVehicleChange(vehicle) {
      if (vehicle) {
        this.handleVehicleSelection(vehicle)
      }
    },

    // Método principal para manejar la selección del vehículo
    handleVehicleSelection(vehicle) {
      if (!vehicle) {
        console.error('Vehículo es null o undefined')
        return
      }

      this.selectedVehicle = vehicle
      
      // Obtener el último movimiento
      if (vehicle.movements && vehicle.movements.length > 0) {
        const sortedMovements = [...vehicle.movements].sort((a, b) => 
          new Date(b.created_at) - new Date(a.created_at)
        )
        this.lastMovement = sortedMovements[0]
      } else {
        this.lastMovement = null
      }
      
      // Ejecutar la lógica de navegación
      this.navigateBasedOnVehicleStatus(vehicle, this.lastMovement)
    },

    // Método para determinar la clase del ítem del vehículo
    getVehicleItemClass(vehicle) {
      if (!vehicle) return 'vehicle-default'
      if (vehicle.__onlyVehicle) return 'vehicle-only-item'
      if (vehicle.__movementItem) {
        // Si es un ítem de movimiento individual, colorear según el tipo
        if (vehicle.movements && vehicle.movements.length > 0) {
          const mov = vehicle.movements[0]
          if (mov.type === 'move') return 'vehicle-movement-item'
          if (mov.type === 'assignment') return 'vehicle-assignment-reported'
        }
        return 'vehicle-movement-item'
      }
      if (!vehicle.movements || vehicle.movements.length === 0) {
        return 'vehicle-default'
      }
      const lastMovement = this.getLastMovement(vehicle)
      if (!lastMovement) {
        return 'vehicle-default'
      }
      // Cesión reportada - fondo rojizo
      if (lastMovement.type === 'assignment' && lastMovement.status === 'reported') {
        return 'vehicle-assignment-reported'
      }
      // Cesión o Movimiento en proceso - fondo verde claro
      if (lastMovement.status === 'processing') {
        return 'vehicle-processing'
      }
      // Movimiento de type entry - fondo blanco
      if (lastMovement.type === 'entry') {
        return 'vehicle-entry'
      }
      return 'vehicle-default'
    },

    // Handler para el item "solo datos del vehículo"
    handleOnlyVehicleClick(vehicle) {
      this.selectedVehicle = vehicle
      this.showVehicleDetailsNuevo()
    },

    // Método auxiliar para obtener el último movimiento
    getLastMovement(vehicle) {
      if (!vehicle || !vehicle.movements || vehicle.movements.length === 0) {
        return null
      }
      
      const sortedMovements = [...vehicle.movements].sort((a, b) => 
        new Date(b.created_at) - new Date(a.created_at)
      )
      
      return sortedMovements[0]
    },
    // Devuelve todos los movimientos no completados
    getPendingMovements(vehicle) {
      if (!vehicle || !vehicle.movements) return []
      return vehicle.movements.filter(mov => mov.status !== 'completed')
    },

    // Devuelve la clase CSS para el movimiento según su tipo/estado
    getMovementClass(mov) {
      if (mov.type === 'move') {
        return 'vehicle-movement-item'
      }
      if (mov.type === 'assignment') {
        return 'vehicle-assignment-reported'
      }
      if (mov.status === 'processing') {
        return 'vehicle-processing'
      }
      if (mov.type === 'entry') {
        return 'vehicle-entry'
      }
      return 'vehicle-default'
    },

    // Método separado para la lógica de navegación
    navigateBasedOnVehicleStatus(vehicle, lastMovement) {
      // Si el vehículo está liberado (free), ir directamente a los detalles
      if (vehicle.status === 'free') {
        this.showVehicleDetailsNuevo()
        return
      }
      
      // Estados que muestran los detalles del vehículo
      if (vehicle.status === 'pending' || 
          (lastMovement !== null && lastMovement.status === 'unreported') || 
          vehicle.status === 'created') {
        this.showVehicleDetails()
        return
      }
      
      // Estados que navegan a detalles nuevos
      if ((lastMovement !== null && lastMovement.type === 'exit') || 
          (lastMovement !== null && lastMovement.type === 'entry') || 
          (lastMovement !== null && lastMovement.type === 'assignment' && lastMovement.status === 'completed')) {
        this.showVehicleDetailsNuevo()
        return
      }
      
      // Estados que muestran el formulario de transporte
      if (lastMovement && 
          (lastMovement.status === 'reported' || 
           lastMovement.status === 'processing' || 
           lastMovement.status === 'completed')) {
        this.showTransportForm()
        return
      }
      // Comportamiento por defecto - mostrar detalles
      this.showVehicleDetails()
    },

    clearError () {
      this.error = ''
    },
    isAddAction () {
      return this.$route.params.action === 'add'
    },
    goToDashboard () {
      this.$router.push({ name: 'Vehiculo' })
    },
    formatAssignmentDate(ts) {
      if (ts === null || ts === undefined || ts === '') return ''
      const n = Number(ts)
      if (isNaN(n)) return ts
      const ms = n < 1e12 ? n * 1000 : n
      const d = new Date(ms)
      if (isNaN(d.getTime())) return ts

      // Forzar zona horaria y formato 24h
      return new Intl.DateTimeFormat('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid' // cambia si necesitas otra zona
      }).format(d)
    },
    formatAssignmentEndDate(ts) {
      if (ts === null || ts === undefined || ts === '') return ''
      const n = Number(ts)
      if (isNaN(n)) return ts
      const ms = n < 1e12 ? n * 1000 : n
      const d = new Date(ms)
      if (isNaN(d.getTime())) return ts

      return new Intl.DateTimeFormat('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid'
      }).format(d)
    },
    // async searchVehicles (ScanData) {
    //   console.log('[DEBUG] searchVehicles called with:', ScanData)
    //   try {
    //     const response = await VehiculoService.get()
    //     let rawList = response.data.data
    //     this.vehiculoState.loading = false
    //     this.noResults = rawList.length === 0

    //     let foundVehicle = null
    //     rawList.forEach(vehicle => {
    //       if (vehicle.frame_number === ScanData || vehicle.plate_number === ScanData) {
    //         foundVehicle = vehicle
    //       }
    //     })

    //     // Flatten list: for vehicles with pending movement, add a special 'only vehicle' item
    //     let newList = []
    //     rawList.forEach(vehicle => {
    //       const lastMov = this.getLastMovement(vehicle)
    //       console.log('[DEBUG] vehicle:', vehicle)
    //       console.log('[DEBUG] lastMov:', lastMov)
    //       if (lastMov && lastMov.status !== 'completed') {
    //         // Add the movement item (normal)
    //         newList.push(vehicle)
    //         // Add the 'only vehicle' item, but with movements: []
    //         const onlyVehicle = {
    //           ...vehicle,
    //           movements: [],
    //           __onlyVehicle: true,
    //           id: vehicle.id + '_only' // unique id for v-autocomplete
    //         }
    //         console.log('[DEBUG] Adding onlyVehicle:', onlyVehicle)
    //         newList.push(onlyVehicle)
    //       } else {
    //         newList.push(vehicle)
    //       }
    //     })
    //     console.log('[DEBUG] Final newList:', newList)
    //     this.vehiculoState.list = newList

    //     if (foundVehicle) {
    //       this.selectedVehicle = foundVehicle
    //       // Actualizar lastMovement para el vehículo encontrado
    //       if (foundVehicle.movements && foundVehicle.movements.length > 0) {
    //         const sortedMovements = [...foundVehicle.movements].sort((a, b) => 
    //           new Date(b.created_at) - new Date(a.created_at)
    //         )
    //         this.lastMovement = sortedMovements[0]
    //       }
    //     } else {
    //       this.error = 'No se encontraron resultados'
    //       this.noResults = true
    //     }
    //   } catch (error) {
    //     console.error('Error al buscar vehículos:', error)
    //     this.error = 'Ocurrió un error al buscar vehículos'
    //   }
    // },
    // async searchVehiclesAdd (ScanData) {
    //   console.log('[DEBUG] searchVehiclesAdd called with:', ScanData)
    //   try {
    //     const response = await VehiculoService.get()
    //     this.vehiculoState.list = response.data.data
    //     this.vehiculoState.loading = false
    //     this.noResults = this.vehiculoState.list.length === 0
        
    //     let foundVehicle = null
    //     this.vehiculoState.list.forEach(vehicle => {
    //       if (vehicle.frame_number === ScanData || vehicle.plate_number === ScanData) {
    //         foundVehicle = vehicle
    //       }
    //     })
        
    //     if (foundVehicle) {
    //       this.selectedVehicle = foundVehicle
    //     } else {
    //       this.error = 'No se encontraron resultados'
    //       this.noResults = true
    //     }
    //   } catch (error) {
    //     console.error('Error al buscar vehículos:', error)
    //     this.error = 'Ocurrió un error al buscar vehículos'
    //   }
    // },
    triggerFileInput () {
      this.$refs.fileInput.click()
    },
    displayText (item) {
      if (!item) return ''
      let base = `${item.brand} ${item.model} - ${item.plate_number}`
      if (item.dealer) {
        base += ` | Dealer: ${item.dealer.name}`
      }
      return base
    },
    filterVehiculos (item, queryText, itemText) {
      return true
    },
    filterVehiculosAdd (item, queryText, itemText) {
      const text = `${item.plate_number}`.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.includes(searchText)
    },
    showVehicleDetails () {
      this.detailsVisible = true
    },
    showVehicleDetailsNuevo () {
      if (this.selectedVehicle && this.selectedVehicle.id) {
        let realId = this.selectedVehicle.id
        if (this.selectedVehicle.__onlyVehicle && typeof realId === 'string' && realId.endsWith('_only')) {
          realId = realId.replace('_only', '')
        }
        this.$router.push({
          name: 'VehiculoDetail',
          params: { id: realId }
        }).then(() => {
          // Limpiar la búsqueda y datos al navegar
          this.clearSearchData()
        })
      } else {
        console.error('No se puede navegar: selectedVehicle o id es null')
        this.detailsVisible = true
        this.error = 'No se puede mostrar los detalles del vehículo'
      }
    },
    showAddForm () {
      this.addForm = true
    },
    showTransportForm () {
      this.detailsVisible = false
      this.transportFormVisible = true
    },
    handleTransportSubmit (data) {
      this.transportFormVisible = false
      // Limpiar datos después de cerrar el formulario de transporte
      this.clearSearchData()
    },
    handleSave (data) {
    },
    handleCancel () {
      this.addForm = false
    },
    formattedMovement (item) {
      if (!item) return 'Matricula: No disponible'
      if (item.status === 'free') {
        return `Matricula: ${item.plate_number || 'No disponible'} - Vehículo archivado`
      }
      // if (item.movements && item.movements.length > 0) {
      //   const lastMovement = this.getLastMovement(item)
      //   if (lastMovement.type === 'assignment') {
      //     return `Matricula: ${item.plate_number} - Cesión`
      //   }
      //   if (lastMovement.status === 'unreported') {
      //     return `Matricula: ${item.plate_number} - Petición de movimiento`
      //   } else if (lastMovement.status === 'reported') {
      //     return `Matricula: ${item.plate_number} - Movimiento reportado`
      //   } else if (lastMovement.status === 'processing') {
      //     return `Matricula: ${item.plate_number} - Movimiento en proceso`
      //   } else if (lastMovement.type === 'entry') {
      //     return `Matricula: ${item.plate_number} - Vehículo recepcionado`
      //   } else {
      //     return `Matricula: ${item.plate_number}`
      //   }
      // } else {
      //   return `Matricula: ${item.plate_number || 'No disponible'}`
      // }
    },
    isExcepcionalMovement(mov) {
      return !!(mov && (mov.is_excepcional === true || mov.is_excepcional === 1 || mov.is_excepcional === '1'))
    },
    getLocationName(vehicle, movement, locationId) {
      if (!locationId) return 'Desconocida'
      const location = this.locationOptions.find(loc => loc.id === locationId)
      if (location) return location.name
      // Si el movimiento es excepcional, cargar los nombres de las ubicaciones
      // de origen/destino usando el endpoint getLocationDealer de los dealers del grupo
      if (this.isExcepcionalMovement(movement)) {
        this.ensureGroupPartnerLocations(vehicle)
        return 'Cargando...'
      }
      return 'Desconocida'
    },
    preloadMovementLocations(list) {
      list.forEach(item => {
        if (item.__movementItem && item.movements && item.movements.length > 0) {
          const mov = item.movements[0]
          if (this.isExcepcionalMovement(mov)) {
            this.ensureGroupPartnerLocations(item)
          }
        }
      })
    },
    ensureGroupPartnerLocations(vehicle) {
      if (this.groupPartnerLocationsLoading || this.groupPartnerLocationsLoaded) return
      this.groupPartnerLocationsLoading = true
      this.loadGroupPartnerLocations(vehicle)
        .finally(() => {
          this.groupPartnerLocationsLoading = false
          this.groupPartnerLocationsLoaded = true
        })
    },
    async loadGroupPartnerLocations(vehicle) {
      try {
        let currentDealerId = this.$store.getters.CURRENT_USER && this.$store.getters.CURRENT_USER.dealer
          ? this.$store.getters.CURRENT_USER.dealer.id
          : null
        if (!currentDealerId && vehicle && vehicle.dealer_id) {
          currentDealerId = vehicle.dealer_id
        }
        if (!currentDealerId) {
          return
        }

        const response = await GrupoService.index({ expand: 'dealerships' })
        const groups = (response.data && response.data.data) || []
        const dealers = []
        groups.forEach(group => {
          const groupDealers = group.dealerships || []
          const isMember = currentDealerId && groupDealers.some(d => d.id === currentDealerId)
          if (isMember) {
            groupDealers.forEach(d => {
              if (d.id !== currentDealerId && !dealers.some(x => x.id === d.id)) {
                dealers.push({ id: d.id, name: d.name })
              }
            })
          }
        })

        // Cargar las ubicaciones de cada dealer partner con getLocationDealer y fusionarlas en locationOptions
        for (const dealer of dealers) {
          const params = {
            'id': dealer.id,
            expand: 'dealer',
            'per-page': 100
          }
          const dealerResponse = await LocationService.getLocationDealer(params)
          let locations = []
          if (dealerResponse.data && dealerResponse.data.data && Array.isArray(dealerResponse.data.data.locations)) {
            locations = dealerResponse.data.data.locations
          } else if (dealerResponse.data && dealerResponse.data.data && Array.isArray(dealerResponse.data.data)) {
            locations = dealerResponse.data.data
          }

          locations.forEach(location => {
            if (!this.locationOptions.some(loc => loc.id === location.id)) {
              this.locationOptions.push({
                id: location.id,
                name: location.name,
                displayName: location.dealer_name ? `${location.name} (${location.dealer_name})` : location.name,
                dealer_id: location.dealer_id,
                is_own: false
              })
            }
          })
        }
      } catch (error) {
        console.error('Error al cargar las ubicaciones de los dealers del grupo:', error)
        this.handleApiError(error, 'Error al cargar las ubicaciones de los dealers del grupo')
      }
    },
    
    // Método para limpiar los datos de búsqueda
    clearSearchData() {
      this.vehiculoState.search = ''
      this.vehiculoState.list = []
      this.vehiculoState.rawList = []
      this.selectedVehicle = null
      this.lastMovement = {}
      this.error = ''
      this.noResults = false
    },
    
    // Handler para cuando se cierra el diálogo de detalles del vehículo
    handleVehicleDetailsClose() {
      this.detailsVisible = false
      this.clearSearchData()
    },
    
    // Handler para cuando se cierra el transport form
    handleTransportFormClose() {
      this.transportFormVisible = false
      this.clearSearchData()
    }
  },
  watch: {
    'vehiculoState.search': _.debounce(function (newSearch) {
      if (newSearch && newSearch.length >= 2) {
        this.vehiculoState.loading = true
        VehiculoService.get({ 'filter[search]': newSearch })
          .then(({ data }) => {
            let rawList = data.data
            this.vehiculoState.rawList = rawList
            let newList = []
            rawList.forEach(vehicle => {
              // Para cada movimiento no completado, crear un item independiente
              if (vehicle.movements && vehicle.movements.length > 0) {
                vehicle.movements.forEach((mov, idx) => {
                  if (mov.status !== 'completed') {
                    // Clonar el vehículo y dejar solo este movimiento
                    newList.push({
                      ...vehicle,
                      movements: [mov],
                      __movementItem: true,
                      id: vehicle.id + '_mov_' + mov.id
                    })
                  }
                })
              }
              // Agregar el item base del vehículo (sin movimientos no completados)
              newList.push({
                ...vehicle,
                movements: [],
                __onlyVehicle: true,
                id: vehicle.id + '_only'
              })
            })
            // Ordenar por datetime de menor a mayor
            newList.sort((a, b) => {
              let aDatetime = 0
              let bDatetime = 0
              if (a.__movementItem && a.movements && a.movements.length > 0) {
                aDatetime = Number(a.movements[0].datetime) || 0
              }
              if (b.__movementItem && b.movements && b.movements.length > 0) {
                bDatetime = Number(b.movements[0].datetime) || 0
              }
              return aDatetime - bDatetime
            })
            this.vehiculoState.list = newList
            this.preloadMovementLocations(newList)
            this.vehiculoState.loading = false
            this.noResults = this.vehiculoState.list.length === 0
            this.error = this.noResults ? 'No se encontraron resultados' : ''
          })
          .catch(error => {
            console.error('Error al buscar vehículos:', error)
            this.error = 'Ocurrió un error al buscar vehículos'
            this.vehiculoState.loading = false
          })
      } else {
        this.vehiculoState.list = []
      }
    }, 350)
  },
  computed: {
    isCollaborator() {
      return this.$store.getters.HAS_ROLE(['colaborator'])
    },
    // P-02: resumen de la operación pendiente mostrada en el aviso.
    pendingMovementSummary() {
      const mov = this.pendingMovement
      if (!mov) return ''
      const typeLabels = {
        entry: '1ª recepción',
        move: 'Movimiento',
        exit: 'Salida',
        assignment: 'Cesión'
      }
      const typeLabel = typeLabels[mov.type] || 'Operación'
      const nameOf = id => {
        if (!id) return null
        const loc = this.locationOptions.find(l => l.id === id)
        return loc ? loc.name : null
      }
      const src = nameOf(mov.source_location_id)
      const dst = nameOf(mov.destination_location_id)
      const route = [src, dst].filter(Boolean).join(' → ')
      let when = ''
      const ts = Number(mov.datetime)
      if (ts) {
        const d = new Date(ts * 1000)
        when = new Intl.DateTimeFormat('es-ES', {
          day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
        }).format(d)
      }
      let line = typeLabel
      if (route) line += ` · ${route}`
      if (when) line += ` · ${when}`
      return line
    }
  }
}
</script>

<style scoped>
/* Estilos originales para PC */
.vehicle-list-item {
  border-radius: 4px;
  max-width: 450px;
  white-space: normal;
  word-break: break-word;
  margin: 2px 0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.vehicle-processing {
  background-color: #e8f5e8 !important;
  border-left: 4px solid #4caf50;
}

.vehicle-entry {
  background-color: #ffffff !important;
  border-left: 4px solid #2196f3;
}

.vehicle-default {
  background-color: #f5f5f5 !important;
  border-left: 4px solid #9e9e9e;
}

.vehicle-assignment-reported {
  background-color: #ffebee !important;
  border-left: 4px solid #e53935;
}

.vehicle-movement-item {
  background-color: #e8f5e8 !important;
  border-left: 4px solid #43a047;
}

/* Hover states para PC */
.vehicle-processing:hover {
  background-color: #d4edda !important;
}

.vehicle-entry:hover {
  background-color: #f0f0f0 !important;
}

.vehicle-default:hover {
  background-color: #e0e0e0 !important;
}

.vehicle-assignment-reported:hover {
  background-color: #ffcdd2 !important;
}

.vehicle-movement-item:hover {
  background-color: #c8e6c9 !important;
}

/* Estilos solo para móvil */
@media (max-width: 768px) {
  .vehicle-list-item {
    padding: 6px 8px;
    margin: 1px 0;
    max-width: 100%;
  }
  
  :deep(.vehicle-list-item .v-list-item__content) {
    padding: 0;
  }
  
  :deep(.vehicle-list-item .v-list-item__title) {
    font-size: 0.85rem;
    line-height: 1.3;
  }
  
  :deep(.vehicle-list-item .v-list-item__subtitle) {
    font-size: 0.75rem;
    line-height: 1.3;
  }
  
  :deep(.vehicle-autocomplete-menu) {
    max-width: 100vw !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 8px;
  }
  
  :deep(.v-autocomplete__content) {
    max-width: 100% !important;
  }
  
  :deep(.v-list) {
    max-width: 100% !important;
    padding: 4px 0;
  }
}

/* Ajustes adicionales para pantallas muy pequeñas */
@media (max-width: 480px) {
  .vehicle-list-item {
    padding: 4px 6px;
  }
  
  :deep(.vehicle-list-item .v-list-item__title) {
    font-size: 0.8rem;
  }
  
  :deep(.vehicle-list-item .v-list-item__subtitle) {
    font-size: 0.7rem;
  }
}
</style>
